import { Card } from "@mui/material";
import React from "react";
import "./css/InfoCard.css";

function InfoCard({ icon, title, description, link }) {
  return (
    <Card className="infoCard-container1">
      <div className="infoCard-header">
        {icon}
        <p style={{fontWeight:"bold"}}>{title}</p>
      </div>
      <div className="infoCard-description">
        <h3>{description}</h3>
        <p className="infoCard-link" onClick={link}>
          View All
        </p>
      </div>
    </Card>
  );
}

export default InfoCard;
